import { Box, Button, List, ListItem, ListItemText, Typography } from '@medely/web-components';
import { ChevronLeft, ChevronRight } from '@medely/web-components/icons';
import { OnboardingDocument } from '@medely/web-components/types';
import { Divider } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';

// {title} is the top-level title displayed above the list
// {documents} should be organized as a nested object with the title of the folder as the object key
//// and the next level nested as an object under that.
//// The final level should be an array of OnboardingDocuments.
// {onChangeLevel} is any extra actions you want to be performs when changing levels.
//// The {level} is provided (starts at 1) and a boolean {finalLevel} representing if you are on the final level
type DocListType = { [key: string]: DocListType | OnboardingDocument[] };

type DocumentListProps = {
  title: string;
  documents: DocListType | OnboardingDocument[];
  onChangeLevel?: (level: number, finalLevel: boolean) => void;
};

const DocumentList = ({ title, documents, onChangeLevel }: DocumentListProps) => {
  const getDisplayList = (list) => {
    if (list) {
      return Array.isArray(list) ? list.map((item) => item.name) : Object.keys(list);
    } else {
      return [];
    }
  };

  // store current states to display
  const [currTitle, setCurrTitle] = useState<string>(title);
  const [currList, setCurrList] = useState<DocListType | OnboardingDocument[]>(documents);

  // store previous states in stack to pop off when traversing backwards
  const [prevTitles, setPrevTitles] = useState<string[]>([]);
  const [prevStates, setPrevStates] = useState<DocListType[]>([]);

  useEffect(() => {
    onChangeLevel && onChangeLevel(prevStates.length, Array.isArray(currList));
  }, [prevStates]);

  const goBack = () => {
    if (prevStates.length > 0) {
      setCurrTitle(prevTitles[prevTitles.length - 1]);
      setPrevTitles(prevTitles.filter((_, index) => index !== prevTitles.length - 1));

      setCurrList(prevStates[prevStates.length - 1]);
      setPrevStates(prevStates.filter((_, index) => index !== prevStates.length - 1));
    }
  };

  const goForward = (key: string, index: number) => {
    if (Array.isArray(currList)) {
      window.open(currList[index].file, '_blank');
    } else {
      setPrevTitles([...prevTitles, currTitle]);
      setCurrTitle(key);

      setPrevStates([...prevStates, currList]);
      setCurrList(currList[key]);
    }
  };

  return (
    <Box pb={2}>
      <Box display="flex">
        {prevStates.length > 0 && (
          <Button
            onClick={goBack}
            style={{ color: '#000', paddingLeft: 0, marginLeft: 0, marginRight: '1rem' }}
          >
            <ChevronLeft />
          </Button>
        )}
        <Typography variant="h6">{currTitle}</Typography>
      </Box>
      <List>
        <Divider />
        {getDisplayList(currList).map((item, index) => (
          <Fragment key={`document-${index}`}>
            <ListItem
              onClick={() => goForward(item, index)}
              style={{ cursor: 'pointer', padding: '1rem 0 1rem 0' }}
            >
              <ListItemText primary={item} />
              <ChevronRight />
            </ListItem>
            <Divider />
          </Fragment>
        ))}
      </List>
    </Box>
  );
};

export default DocumentList;
